import { render, staticRenderFns } from "./ChallengeObjectiveModal.vue?vue&type=template&id=62b85c78"
import script from "./ChallengeObjectiveModal.vue?vue&type=script&lang=js"
export * from "./ChallengeObjectiveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports